export default "__VITE_ASSET__BboLwJW0__"